<template>
    <v-dialog v-model="detail_order" @click:outside="closeDetail">
        <v-card>
            <v-card-title>
                {{ detail_type.text }} Details {{ order.id }}
                <v-spacer></v-spacer>
                <v-chip v-if="order.OrderStatus == 'payment_pending'">
                    Payment Pending
                </v-chip>
                <v-chip v-else-if="order.OrderStatus == 'payment_success'" color="green" text-color="white">
                    Payment Success
                </v-chip>
                <v-chip v-else-if="order.OrderStatus == 'canceled'" color="red" text-color="white">
                    Canceled
                </v-chip>
                <v-chip v-else-if="order.OrderStatus == 'payment_expired'" color="red" text-color="black">
                    Canceled
                </v-chip>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="justify-space-around">
                        <v-col cols="3">
                            <h4 class="text--futura">Date</h4><br>
                            <span class="text--futura">
                                {{ formatDate(order.order_date) }}
                            </span>
                        </v-col>
                        <v-col cols="3">
                            <h4 class="text--futura">Customer</h4><br>
                            <span class="text--futura">
                                {{ order.Customer ? order.Customer.fullName : "-"}}
                            </span>
                        </v-col>
                        <v-col cols="3">
                            <h4 class="text--futura">Contact</h4><br>
                            <span class="text--futura">
                                {{ order.Customer ? order.Customer.CustomerContact.contactNo : "-"}}
                            </span>
                        </v-col>
                        <v-col cols="3">
                            <h4 class="text--futura">Destination</h4><br>
                            <span class="text--futura">
                                {{ `${order.ShipFromLocation ? order.ShipFromLocation.LocationName : ""} - ${order.ShiptoAddress} (${order.ShipFromLocation ? order.postal_code : ""})` }}
                            </span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <h4 class="text--futura">Product</h4>
                        </v-col>
                        <v-col cols="3">
                            <h4 class="text--futura">Quantity</h4>
                        </v-col>
                        <v-col cols="3">
                            <h4 class="text--futura">Price Each</h4>
                        </v-col>
                        <v-col cols="3">
                            <h4 class="text--futura">Price</h4>
                        </v-col>
                    </v-row>
                    <hr>
                    <div v-if="order.OrderLine">
                        <v-row v-for="product in order.OrderLine.items" :key="product.id">
                        <v-col cols="3">
                            <span class="text--futura">{{ product.Item.name }}</span>
                        </v-col>
                        <v-col cols="3">
                            <span class="text--futura">{{ product.qty }}</span>
                        </v-col>
                        <v-col cols="3">
                            <span class="text--futura">{{ formatHarga(getEffectiveItemPrice(product)) }}</span>
                        </v-col>
                        <v-col cols="3">
                            <span class="text--futura">{{ formatHarga(getLineSubtotal(product)) }}</span>
                        </v-col>
                    </v-row>
                    </div>
                    <hr>
                    <v-row justify="end" no-gutters class="pb-5">
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <v-row no-gutters class="mb-2">
                                <v-col cols="5">
                                    <span>Sub Total</span>
                                </v-col>
                                <v-col cols="7" class="text-right">
                                    <span>{{ formatHarga(price_total) }}</span>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="mb-2">
                                <v-col cols="5">
                                    <span>Tax</span>
                                </v-col>
                                <v-col cols="7" class="text-right">
                                    <span>{{ `(${order.tax}%)` }} {{ formatHarga(tax_amount) }}</span>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="mb-2">
                                <v-col cols="5">
                                    <span>Delivery Fee</span>
                                </v-col>
                                <v-col cols="7" class="text-right">
                                    <span>{{ formatHarga(order.delivery_fee) }}</span>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="5">
                                    <span>Total</span>
                                </v-col>
                                <v-col cols="7" class="text-right">
                                    <span>{{ formatHarga(grand_total) }}</span>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <hr>
                    <v-row class="justify-space-around">
                        <v-col cols="3">
                            <h4 class="text--futura">Ship From</h4><br>
                            <v-autocomplete
                                solo
                                :items="warehouses"
                                placeholder="Warehouse Location"
                                append-icon="mdi-magnify"
                                item-text="LocationName"
                                item-value="id"
                                v-model="order.ShipFromLocationId"
                            >    
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                            <h4 class="text--futura">Shipment Date</h4><br>
                                <v-col
                            cols="12"
                            >
                                <v-menu
                                    ref="menu2"
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :return-value.sync="shipment_date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="shipment_date"
                                        label="Shipment Date"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        solo
                                        append-icon="mdi-calendar"
                                        clearable
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="shipment_date"
                                        no-title
                                        scrollable
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menu2 = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu2.save(shipment_date)"
                                    >
                                        OK
                                    </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-col>
                        <!-- <v-col cols="3">
                            <h4 class="text--futura">Memo</h4><br>
                            <v-text-field
                                solo
                                placeholder="Enter Memo"
                                v-model="order.memo"
                            >
                            </v-text-field>
                        </v-col> -->
                        <v-col cols="3">
                            <h4 class="text--futura">QB Status</h4><br>
                            <span class="text--futura" v-if="(qbStatus)">
                                {{ qbStatus }}
                            </span>
                            <!-- <v-text-field
                                v-if="(order.Payment)"
                                solo
                                placeholder="Enter Memo"
                                v-model="order.Payment.payment_method"
                            >
                            </v-text-field> -->
                        </v-col>
                        <v-col cols="3">
                            <h4 class="text--futura">Payment Method</h4><br>
                            <span class="text--futura" v-if="(order.Payment)">
                                {{ order.Payment.payment_method }}
                            </span>
                            <!-- <v-text-field
                                v-if="(order.Payment)"
                                solo
                                placeholder="Enter Memo"
                                v-model="order.Payment.payment_method"
                            >
                            </v-text-field> -->
                        </v-col>
                    </v-row>
                    <v-row class="justify-space-around">
                        <v-col cols="3">
                            <h4 class="text--futura">Shipping Status</h4><br>
                            <v-select solo label="Shipping Status" :items="shipment_statuses" item-text="label" item-value="value" v-model="ShipStatus">
                            </v-select>
                        </v-col>
                        <v-col cols="3">
                            <h4 class="text--futura">Input Courier</h4><br>
                            <v-select solo label="Choose Courier" :items="couriers" item-text="CourierCompany"
                                item-value="id" v-model="order.DeliveryMethodId">
                            </v-select>
                        </v-col>
                        <v-col cols="3">
                            <h4 class="text--futura">Courier Tracking Code</h4><br>
                            <v-text-field solo placeholder="Courier Tracking Code" v-model="tracking_code">
                            </v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <h4 class="text--futura">Payment Status</h4><br>
                            <v-select solo label="Set Status" :items="order_statuses" v-model="OrderStatus">
                            </v-select>
                        </v-col>
                    </v-row>
                    <!-- <v-row>
                        <v-col cols="12">
                            <h4>Payment to Account</h4>
                            <v-select solo label="Enter Account">
                            </v-select>
                        </v-col>
                    </v-row> -->
                    <v-row justify="center">
                        <Alert />
                    </v-row>
                    <v-row class=" justify-end">
                        <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    style="width: 60px"
                                    medium
                                    v-bind="attrs"
                                    v-on="on"
                                >mdi-printer</v-icon>
                            </template>
                            <v-list>
                                <v-list-item>
                                    <v-list-item-title>
                                        <v-btn text @click.prevent="printInvoice('ppn_detail')" class="text--futura text-capitalize mr-3">
                                            <v-icon small>mdi-printer</v-icon> PPN Detail
                                        </v-btn>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title>
                                        <v-btn text @click.prevent="printInvoice('ppn_simple')" class="text--futura text-capitalize mr-3">
                                            <v-icon small>mdi-printer</v-icon> PPN Simple
                                        </v-btn>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title>
                                        <v-btn text @click.prevent="printInvoice('detail')" class="text--futura text-capitalize mr-3">
                                            <v-icon small>mdi-printer</v-icon> Detail
                                        </v-btn>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title>
                                        <v-btn text @click.prevent="printInvoice('simple')" class="text--futura text-capitalize mr-3">
                                            <v-icon small>mdi-printer</v-icon> Simple
                                        </v-btn>
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <div>
                            <p>&nbsp;&nbsp;</p>
                        </div>
                        <!-- <v-btn class="text--futura text-capitalize mr-3" @click.prevent="printInvoice()">
                            <v-icon>
                                mdi-printer
                            </v-icon>
                        </v-btn> -->
                        <v-btn dark class="text--futura text-capitalize mr-3" @click.prevent="qbOrderInvoice(order.id)" :loading="loadingQB">
                            QB Status
                        </v-btn>
                        <router-link :to="`/dashboard/add/return/${order.id}`">
                            <v-btn class="text--futura text-capitalize mr-3">
                                Return {{ detail_type.text }}
                            </v-btn>
                        </router-link>
                        <v-btn dark class="text--futura text-capitalize mr-3" @click.prevent="jubelioSync(order.id)" :loading="loadingJubelio">
                            Jubelio {{ detail_type.text }}
                        </v-btn>
                        <router-link :to="`/dashboard/add/order`">
                            <v-btn dark class="text--futura text-capitalize mr-3" @click="duplicateData()">
                                Duplicate {{ detail_type.text }}
                            </v-btn>
                        </router-link>
                        <router-link :to="`/dashboard/edit/order/${order.id}`">
                            <v-btn dark class="text--futura text-capitalize mr-3">
                                Edit {{ detail_type.text }}
                            </v-btn>
                        </router-link>
                        <v-btn dark class="text--futura text-capitalize mr-3" @click.prevent="shippingLabel()">
                            Generate Shipping Label
                        </v-btn>
                        <v-btn dark v-if="order.DeliveryMethodId == 8" class="text--futura text-capitalize mr-3" @click.prevent="orderGojek(order.id)">
                            Order Gojek
                        </v-btn>
                        <v-btn dark class="text--futura text-capitalize mr-3" @click.prevent="updateOrder(order.id)">
                            Save
                        </v-btn>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import server from '../api'
import Alert from '@/components/Alert.vue'

export default {
    name: 'DetailOrder',
    components: {
        Alert
    },
    data () {     
        let qbPaymentData = [] 
        return {
            qbPaymentData,
            qbStatus: '',
            loadingQB:false,
            loadingJubelio:false,
            messageJubelio: null,
            dataJubelio: null
        }
    },
    props: {
        
        detail_order: {
            type: Boolean,
            default: false
        },
        order: {
            type: Object,
            default: () => {
                return {
                    city_id: '',
                    province_id: '',
                    ShiptoAddress: '',
                    ShipStatus: '',
                    OrderStatus: '',
                    ShipFromLocationId: '',
                    order_date: new Date().toISOString().substr(0, 10),
                    shipment_date: new Date().toISOString().substr(0, 10),
                    DeliveryMethodId: 1,
                    sales_type: '',
                    customer_type: '',
                    Customer: {
                        fullName: '',
                        CustomerContact: {
                            contactNo: ''
                        }
                    },
                    Payment: {},
                    ShipFromLocation: {},
                    DeliveryMethod: {},
                    OrderLine: {
                        items: []
                    },
                    tax: 0,
                    delivery_fee: 0,
                    memo: '',
                }
            }
        },
        detail_type: {
            type: Object,
            default: () => {
                return {
                    text: 'Order',
                    value: 'order'
                }
            }
        }
    },
    mounted: function () {
        this.qbStatus = '';
    },
    methods: {
        toNumber(value) {
            const parsedValue = Number(value);
            return Number.isFinite(parsedValue) ? parsedValue : 0;
        },
        getEffectiveItemPrice(item) {
            if (item && item.price !== undefined && item.price !== null && item.price !== '') {
                return this.toNumber(item.price);
            }

            if (item && item.Item) {
                if (item.Item.retail_price !== undefined && item.Item.retail_price !== null && item.Item.retail_price !== '') {
                    return this.toNumber(item.Item.retail_price);
                }

                if (item.Item.gross_price !== undefined && item.Item.gross_price !== null && item.Item.gross_price !== '') {
                    return this.toNumber(item.Item.gross_price);
                }
            }

            return 0;
        },
        getCatalogGrossPrice(item) {
            if (item && item.Item && item.Item.gross_price !== undefined && item.Item.gross_price !== null && item.Item.gross_price !== '') {
                return this.toNumber(item.Item.gross_price);
            }

            return this.getEffectiveItemPrice(item);
        },
        getLineSubtotal(item) {
            return this.toNumber(item && item.qty) * this.getEffectiveItemPrice(item);
        },
        getOrderSubtotal(items = []) {
            return items.reduce((total, item) => total + this.getLineSubtotal(item), 0);
        },
        getTaxAmount(subtotal = 0) {
            return subtotal * (this.toNumber(this.order.tax) / 100);
        },
        getItemsSubtotal(items = []) {
            return items.reduce((total, item) => total + this.getLineSubtotal(item), 0);
        },
        getPpnSubtotalExcludingTax(items = []) {
            return this.getItemsSubtotal(items) / 1.11;
        },
        getPpnAmount(subtotal = 0, items = []) {
            return this.getItemsSubtotal(items) - subtotal;
        },
        getPpnGrandTotal(items = []) {
            return this.getItemsSubtotal(items) + this.toNumber(this.order.delivery_fee);
        },
        getPpnTotals(items = []) {
            const subtotalExcludingTax = this.getPpnSubtotalExcludingTax(items);
            const taxAmount = this.getPpnAmount(subtotalExcludingTax, items);
            const grandTotal = this.getPpnGrandTotal(items);

            return {
                subtotalExcludingTax,
                taxAmount,
                grandTotal
            };
        },
        getGrandTotal(subtotal = 0, taxAmount = 0) {
            return subtotal + taxAmount + this.toNumber(this.order.delivery_fee);
        },
        getMarginPercentage(item) {
            const effectivePrice = this.getEffectiveItemPrice(item);
            const listPrice = this.getCatalogGrossPrice(item);

            if (!listPrice) return '0%';

            return `${(100 - ((effectivePrice / listPrice) * 100)).toFixed(0)}%`;
        },
        sub_total(price, qty) {
            return price * qty
        },
        closeDetail() {
            this.$emit('closeDetail');
        },
        printInvoice(docFormat) {
            let pdfName = `Invoices ${this.order.id}`;
            let doc = new jsPDF('p', 'mm', 'a4');
            const allItems = this.order && this.order.OrderLine ? this.order.OrderLine.items || [] : [];
            const ppnTotals = this.getPpnTotals(allItems);


            let logo = 'data:image/png;base64,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'

            let size = 10;
            let arrayItems = [];

            for (let i = 0; i < this.order.OrderLine.items.length; i += size) {
                arrayItems.push(this.order.OrderLine.items.slice(i, i + size));
            }
            //console.log(docFormat);
            if (docFormat === "ppn_detail") {
                for (let i = 0; i < arrayItems.length; i++) {
                    this.invoicePagePPNDetail(doc, logo, arrayItems[i], ppnTotals);
                    if (i !== arrayItems.length - 1) {
                        doc.addPage('a4', 'p');
                    }
                }
            } else if (docFormat === "simple") {  
                for (let i = 0; i < arrayItems.length; i++) {
                    this.invoicePage(doc, logo, arrayItems[i]);
                    if (i !== arrayItems.length - 1) {
                        doc.addPage('a4', 'p');
                    }
                }
            } else if (docFormat === "detail") {  
                for (let i = 0; i < arrayItems.length; i++) {
                    this.invoicePageDetail(doc, logo, arrayItems[i]);
                    if (i !== arrayItems.length - 1) {
                        doc.addPage('a4', 'p');
                    }
                }
            } else if (docFormat === "ppn_simple") {  
                for (let i = 0; i < arrayItems.length; i++) {
                    this.invoicePagePPNSimple(doc, logo, arrayItems[i], ppnTotals);
                    if (i !== arrayItems.length - 1) {
                        doc.addPage('a4', 'p');
                    }
                }
            }


            for (let i = 0; i < arrayItems.length; i++) {
                doc.addPage('a4', 'p');
                this.packingList(doc, logo, arrayItems[i]);
            }

            doc.save(`${pdfName}.pdf`);

        },
        packingList(doc, logo, items) {
            doc.addImage(logo, "PNG", 15, 5, 30, 30);
            doc.setFillColor(0, 51, 102);
            doc.rect(0, 35, 100, 12, 'F');
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(30);
            doc.text('PACKING LIST', 105, 45, { align: 'justify', charSpace: 1 });
            doc.setFillColor(0, 51, 102);
            doc.rect(195, 35, 50, 12, 'F');

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(14);

            doc.text('Ship To:', 15, 60, { charSpace: 0 });
            doc.text(`${this.order.Customer.fullName}`, 35, 60);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(10);
            doc.text(`${this.order.ShiptoAddress ? this.order.ShiptoAddress : ''} ${this.order.City ? `, ${this.order.City.type} ${this.order.City.name}, ${this.order.City.Province.name}` : ''}`, 15, 65, { maxWidth: 100 });

            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');

            doc.text('Invoice #', 120, 62);
            doc.text(`${this.order.id}`, 150, 62);
            doc.text('Invoice Date', 120, 67);
            doc.text(this.formatDate(this.order.order_date), 150, 67);
            doc.text('Payment Due', 120, 72);
            doc.text(this.formatHarga(this.grand_total), 150, 72);

            let tableBody = items.map((order) => {
                return [order.Item.name, order.qty, `${order.gross_weight} Kg`]
            });

            autoTable(doc, {
                head: [['Item Descriptions', 'Qty', 'Gross Weight']],
                body: tableBody,
                startY: 90,
                theme: 'striped',
                headStyles: {
                    textColor: 'white',
                    fillColor: [64, 64, 64]
                },
                styles: {
                    fillColor: [204, 204, 204],
                    textColor: 'black'
                }
            });

            doc.text('Issued By:', 20, 225);
            doc.addImage(logo, 'PNG', 20, 230, 30, 30);
            doc.text('Received By:', 60, 225);

            doc.setFillColor(0, 51, 102);
            doc.rect(0, 285, doc.internal.pageSize.getWidth(), 2, 'F');
        },
        invoicePageBasic(doc, logo, amountDue = this.grand_total) {
            doc.addImage(logo, "PNG", 15, 5, 30, 30);
            doc.setFillColor(0, 51, 102);
            doc.rect(0, 35, 115, 12, 'F');
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(36);
            doc.text('INVOICE', 120, 45, { align: 'justify', charSpace: 1 });
            doc.setFillColor(0, 51, 102);
            doc.rect(185, 35, 50, 12, 'F');
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(14);
            doc.text('Bill To:', 15, 60, { charSpace: 0 });
            doc.text(`${this.order.Customer.company_name ? this.order.Customer.company_name : ''}`, 35, 60);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(10);
            doc.text(`${this.order.Customer.CustomerContact.invoice_address ? this.order.Customer.CustomerContact.invoice_address : ''} ${this.order.Customer.CustomerContact.City ? `, ${this.order.Customer.CustomerContact.City.type} ${this.order.Customer.CustomerContact.City.name}, ${this.order.Customer.CustomerContact.City.Province.name}` : ''}`, 15, 65, { maxWidth: 100 });
            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');
            doc.text('Invoice #', 120, 62);
            doc.text(`${this.order.id}`, 150, 62);
            doc.text('Invoice Date', 120, 67);
            doc.text(this.formatDate(this.order.order_date), 150, 67);
            doc.text('Payment Due', 120, 72);
            doc.text(this.formatHarga(amountDue), 150, 72);
            doc.text('Amount Due', 120, 77);
            doc.text(this.formatHarga(amountDue), 150, 77);

            doc.text('Issued By:', 20, 225);
            doc.addImage(logo, 'PNG', 20, 230, 30, 30);
            doc.setFillColor(204, 204, 204);
            doc.rect(100, 220, 85, 30, 'F');
            doc.setFontSize(12);
            doc.text('Total Payment Due', 105, 228);
            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            doc.text(this.formatHarga(amountDue), 115, 240);
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.text('Bank Transfer', 105, 260);
            doc.setFontSize(8);
            doc.setFont('helvetica', 'normal');
            doc.text('A/C: 2414876888 (PT Urchindize Indonesia)', 105, 265)
            doc.text('Bank Central Asia', 105, 270);
            
        },
        invoicePage(doc, logo, items) {
            let pageWidth = doc.internal.pageSize.getWidth();
            this.invoicePageBasic(doc,logo);

            let tableBody = items.map(order => {
                const effectivePrice = this.getEffectiveItemPrice(order);
                return [order.Item.name, order.qty, effectivePrice, (this.toNumber(order.qty) * effectivePrice)]
            });
            autoTable(doc, {
                head: [['Item Descriptions', 'Qty', 'Rate', 'Amount']],
                body: tableBody,
                startY: 90,
                theme: 'striped',
                headStyles: {
                    textColor: 'white',
                    fillColor: [64, 64, 64]
                },
                styles: {
                    fillColor: [204, 204, 204],
                    textColor: 'black'
                }
            });
            doc.setFillColor(0, 51, 102);
            doc.rect(0, 285, pageWidth, 2, 'F');
            
        },
        invoicePagePPNDetail(doc, logo, items, totals) {
            let pageWidth = doc.internal.pageSize.getWidth();

            this.invoicePageBasic(doc, logo, totals.grandTotal);

            let tableBody = items.map(order => {
                const effectivePrice = this.getEffectiveItemPrice(order);
                const listPrice = this.getCatalogGrossPrice(order);
                return [
                    order.Item.name,
                    order.qty,
                    (listPrice / 1.11).toFixed(2),
                    this.getMarginPercentage(order),
                    (effectivePrice / 1.11).toFixed(2),
                    ((this.toNumber(order.qty) * effectivePrice) / 1.11).toFixed(2)
                ]
            });
            const { subtotalExcludingTax, taxAmount, grandTotal } = totals;
            //console.log(items);
            autoTable(doc, {
                head: [['Item Descriptions', 'Qty','List Price', 'Margin', 'Rate', 'Amount']],
                body: tableBody,
                startY: 90,
                theme: 'striped',
                headStyles: {
                    textColor: 'white',
                    fillColor: [64, 64, 64]
                },
                styles: {
                    fillColor: [204, 204, 204],
                    textColor: 'black'
                }
            });

            doc.text('Sub-total: ', 140, 195);
            doc.text(subtotalExcludingTax.toFixed(2).toString(), 170, 195);
            doc.text('PPN (11%): ', 140, 200);
            doc.text(taxAmount.toFixed(2).toString(), 170, 200);
            doc.text('Shipping: ', 140, 205);
            doc.text(`${this.toNumber(this.order.delivery_fee)}`, 170, 205);
            doc.text('Grand Total: ', 140, 210);
            doc.text(grandTotal.toFixed(2).toString(), 170, 210);
            
            //doc.text(`Or BCA Virtual Account: 123690${this.order.Customer.CustomerContact.contactNo.substring(3)}`, 105, 275)

            doc.setFillColor(0, 51, 102);
            doc.rect(0, 285, pageWidth, 2, 'F');
        },
        invoicePagePPNSimple(doc, logo, items, totals) {
            let pageWidth = doc.internal.pageSize.getWidth();

            this.invoicePageBasic(doc, logo, totals.grandTotal);

            let tableBody = items.map(order => {
                const effectivePrice = this.getEffectiveItemPrice(order);
                return [order.Item.name, order.qty, (effectivePrice / 1.11).toFixed(2), ((this.toNumber(order.qty) * effectivePrice) / 1.11).toFixed(2)]
            });
            const { subtotalExcludingTax, taxAmount, grandTotal } = totals;
            //console.log(items);
            autoTable(doc, {
                head: [['Item Descriptions', 'Qty', 'Rate', 'Amount']],
                body: tableBody,
                startY: 90,
                theme: 'striped',
                headStyles: {
                    textColor: 'white',
                    fillColor: [64, 64, 64]
                },
                styles: {
                    fillColor: [204, 204, 204],
                    textColor: 'black'
                }
            });
            doc.text('Sub-total: ', 140, 195);
            doc.text(subtotalExcludingTax.toFixed(2).toString(), 170, 195);
            doc.text('PPN (11%): ', 140, 200);
            doc.text(taxAmount.toFixed(2).toString(), 170, 200);
            doc.text('Shipping: ', 140, 205);
            doc.text(`${this.toNumber(this.order.delivery_fee)}`, 170, 205);
            doc.text('Grand Total: ', 140, 210);
            doc.text(grandTotal.toFixed(2).toString(), 170, 210);

            //doc.text(`Or BCA Virtual Account: 123690${this.order.Customer.CustomerContact.contactNo.substring(3)}`, 105, 275)

            doc.setFillColor(0, 51, 102);
            doc.rect(0, 285, pageWidth, 2, 'F');
        },
        invoicePageDetail(doc, logo, items) {
            let pageWidth = doc.internal.pageSize.getWidth();

            this.invoicePageBasic(doc,logo);

            let tableBody = items.map(order => {
                const effectivePrice = this.getEffectiveItemPrice(order);
                return [order.Item.name, order.qty, this.getCatalogGrossPrice(order).toFixed(2), this.getMarginPercentage(order), effectivePrice, (this.toNumber(order.qty) * effectivePrice).toFixed(2)]
            });
            //console.log(items);
            autoTable(doc, {
                head: [['Item Descriptions', 'Qty','List Price', 'Margin', 'Rate', 'Amount']],
                body: tableBody,
                startY: 90,
                theme: 'striped',
                headStyles: {
                    textColor: 'white',
                    fillColor: [64, 64, 64]
                },
                styles: {
                    fillColor: [204, 204, 204],
                    textColor: 'black'
                }
            });
            doc.text('Sub-total: ', 140, 200);
            doc.text(this.price_total.toFixed(2).toString(), 170, 200);
            // doc.text('PPN (11%): ', 140, 200);
            // doc.text(((subTotal*0.11).toFixed(2)).toString(), 170, 200);
            doc.text('Shipping: ', 140, 205);
            doc.text(`${this.toNumber(this.order.delivery_fee)}`, 170, 205);
            doc.text('Grand Total: ', 140, 210);
            doc.text(this.grand_total.toFixed(2).toString(), 170, 210);

            //doc.text(`Or BCA Virtual Account: 123690${this.order.Customer.CustomerContact.contactNo.substring(3)}`, 105, 275)

            doc.setFillColor(0, 51, 102);
            doc.rect(0, 285, pageWidth, 2, 'F');
        },
        orderGojek(id) {
            this.loadingGojek = true;
            server.post(`/gojek/order`, { order_id: id }, {
                headers: {
                    token: localStorage.token
                }
            })
            .then(({ data }) => {
                this.loadingGojek = false;
                this.$store.commit('SET_SUCCESS', data.message);
            })
            .catch(err => {
                console.log(err.response.data.message, 'ini error')
                this.loadingGojek = false;
                this.$store.commit('SET_ERROR', err.response.data.message);
            })
        },
        shippingLabel() {
            let pdfName = `Shipping-Label-${this.order.id}`
            let doc = new jsPDF('p', 'mm', [150, 110]);
            //console.log(doc.getFontList())
            //doc.addFont('helvetica', "bold");
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            doc.text(`Order No. ${this.order.id}`, 5, 10);
            doc.text(`Kurir. ${this.order.DeliveryMethod.CourierCompany}`, 32, 10);
            doc.text(`Resi No. ${this.order.tracking_code ? this.order.tracking_code : ''}`, 52, 10, { maxWidth: 100 });
            doc.setFont('helvetica', 'bold');
            doc.text(`Kepada`, 5, 20);
            doc.text(`Dari`, 70, 20);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            doc.text(`${this.order.ShiptoAddress}`, 5, 30, { maxWidth: 50 });
            if (this.order.Customer) {
                doc.text(`${this.order.Customer.fullName}`, 5, 25);
                // doc.text(`${this.order.Customer.CustomerContact.addressLine1}`, 5, 40);
                //doc.text(`${this.order.Customer.CustomerContact.addressLine2}`, 5, 45);
                if (this.order.City) {
                    doc.text(`${this.order.City.type} ${this.order.City.name}`, 5, 65);
                    //provinceName.then(response => response.json()).then((json) => {console.log('this is the json data', json)})
                    //var parsedProvinceName = JSON.parse(provinceName);
                    //console.log(typeof provinceName[0]);
                    doc.text(`${this.order.City.Province.name}`, 5, 70);
                }
                doc.text(`${this.order.Customer.CustomerContact.contactNo ? this.order.Customer.CustomerContact.contactNo : ''}`, 5, 75);
                doc.text(`Memo: ${this.order.memo}`, 5, 80, { maxWidth: 100 });
            }
            doc.text(`Crystal of the Sea`, 70, 25);
            doc.text(`${this.order.ShipFromLocation.LocationName ? this.order.ShipFromLocation.LocationName : ''}`, 70, 30);
            //doc.text(`${this.order.Customer.CustomerContact.addressLine2}`, 50, 45)
            doc.text(`${this.order.ShipFromLocation.City.type ? this.order.ShipFromLocation.City.type : ''} ${this.order.ShipFromLocation.City.name ? this.order.ShipFromLocation.City.name : ''}`, 70, 65);
            doc.text(`${this.order.ShipFromLocation.City.Province.name ? this.order.ShipFromLocation.City.Province.name : ''}`, 70, 70);
            //doc.text(`${this.order.Customer.CustomerContact.province_id}`, 50, 55)
            doc.text(`628113011132`, 70, 75);
            doc.line(5, 85, 105, 85);
            doc.setFont('helvetica', 'bold');
            doc.text(`SKU`, 60, 90);
            doc.text(`Jumlah`, 75, 90);
            doc.setFont('helvetica', 'normal');
            const itemList = this.order.OrderLine.items;
            var itemCount = Object.keys(itemList).length;
            //console.log(itemCount);
            var spacing = 5;
            if (itemCount > 6) {
                spacing = 3
                doc.setFontSize(6);
            }
            for (var i = 0; i < itemCount; i++) {
                //console.log(itemList[i].Item.name);
                doc.text(itemList[i].Item.name, 5, 95 + i * spacing, { maxWidth: 50 });
                doc.text(itemList[i].Item.sku, 60, 95 + i * spacing);
                doc.text(`${itemList[i].qty}`, 75, 95 + i * spacing);
                let width = doc.getTextWidth(itemList[i].Item.name);
                if (width > 50) spacing = 10;
            }
            //doc.text(`${this.order.OrderLine.items[0].Item.name}`, 5, 75)
            doc.rect(3, 3, 105, 145)
            doc.save(pdfName + '.pdf')
            if (this.order.ShipStatus === 'Processed') {
                this.order.ShipStatus = 'Label Printed';
                this.$emit('updateOrder', this.order.id)
            }
        },
        updateOrder(id) {
            if (this.order.tracking_code !== '' && (this.order.ShipStatus === 'Label Printed' || this.order.ShipStatus === 'Processed')) {
                this.order.ShipStatus = 'Shipped';
            }
            this.$emit('updateOrder', id)
        },
        duplicateData() {
            this.$session.set("isDuplicate", 1);
            this.$session.set("orderData", this.order);
            //console.log(this.$session.get("orderData").Customer.CustomerContact.contactNo);
        },
        async jubelioSync(id) {
            try {
                this.loadingJubelio = true
                let {data} = await server.post(`/jubelios/${id}`, null, {
                    headers: {
                        token:localStorage.token
                    }
                })
                this.dataJubelio = data
                this.loadingJubelio = false
                this.$store.commit('SET_SUCCESS', data.message);
            } catch (error) {
                this.message = error.response.data.errors
                this.loadingJubelio = false
                this.$store.commit('SET_ERROR', this.message);
            }
             
        },
        async qbOrderInvoice(id) {
            console.log(id);
            try {
                this.loadingQB = true;
                let { data } = await server.get(`/quickbooks/orderInvoice/${id}`, null, {
                    headers: {
                        token: localStorage.token
                    }
                })
                
                this.qbPaymentData = data;
                if (this.qbPaymentData.invoice === "No QB Id" ) {
                    this.qbStatus = 'Not imported to Quickbooks';
                } else {
                    if (this.qbPaymentData.payment){
                        this.qbStatus = `${ this.qbPaymentData.payment[0].TxnDate }, ${ this.qbPaymentData.payment[0].DepositToAccountRefFullName }, ${ this.qbPaymentData.paymentAmount }`;
                    } else {
                        this.qbStatus = 'No Payment';
                    }
                }
                this.loadingQB = false;
                
            } catch (error) {
                this.message = error.response.data.errors;
                this.qbPaymentData = [];
                this.qbStatus = 'Error';
                this.loadingQB = false;
            }
            
            //console.log(this.qbPaymentData);
        },
    },
    computed: {
        shipment_statuses() {
            return this.$store.state.shipment_statuses;
        },
        order_statuses() {
            return this.$store.state.order_statuses;
        },
        warehouses () {
            return this.$store.state.warehouses
        },
        shipment_date: {
            get: function () {
                return this.order.shipment_date ? this.formatDate(this.order.shipment_date, 'YYYY-MM-DD') : '';
            },
            set: function (value) {
                this.order.shipment_date = value
            }
        },
        OrderStatus: {
            get: function () {
                return this.order.OrderStatus
            },
            set: function (value) {
                this.order.OrderStatus = value
            }
        },
        tracking_code: {
            get: function () {
                return this.order.tracking_code
            },
            set: function (value) {
                this.order.tracking_code = value
            }
        },
        ShipStatus: {
            get: function () {
                return this.order.ShipStatus
            },
            set: function (value) {
                this.order.ShipStatus = value
            }
        },
        couriers() {
            return this.$store.state.couriers
        },
        price_total() {
            const items = this.order && this.order.OrderLine ? this.order.OrderLine.items || [] : [];
            return this.getOrderSubtotal(items)
        },
        tax_amount() {
            return this.getTaxAmount(this.price_total);
        },
        grand_total() {
            return this.getGrandTotal(this.price_total, this.tax_amount)
        },
    },
    created() {
        this.$store.dispatch('getCouriers');
        this.$store.dispatch('getWarehouses');
    }
}
</script>

<style>
</style>
